import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { WebShopService } from "../../services/webShop.service";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute } from "@angular/router";

export const enum FixedBasketErrorCodes {
  NoBasket,
  ProductsNotUptodate,
}
@Component({
  selector: "fixedBasketErrorPage",
  templateUrl: "./fixedBasketErrorPage.component.html",
  styleUrls: ["./fixedBasketErrorPage.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FixedBasketErrorPageComponent implements OnInit {

  public returnURL: string = "";
  public errorCode = FixedBasketErrorCodes.NoBasket;

  constructor(
    private _webShopService: WebShopService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _activatedRoute: ActivatedRoute,
    ) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("OrderResultComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public get messagePlaceholder(): string {
    switch (this.errorCode) {
      case FixedBasketErrorCodes.NoBasket: {
        return "phFixedBasketErrorPage_NoBasket_Text";
      }
      case FixedBasketErrorCodes.ProductsNotUptodate: {
        return "phFixedBasketErrorPage_PleaseTryAgainLater_Text";
      }
    }
  }

  ngOnInit() {
    const me = this;
    me.returnURL = me._webShopService.returnURLBasket;
    me._webShopService.toggleFixedMode(true);
    me.errorCode = +(me._activatedRoute.snapshot.paramMap.get("errorCode"));
    me.PushChanges();
  }

}
